export const USAGE_ANALYTICS_UNAVAILABLE = "Usage analytics are unavailable";
export const USAGE_RESPONSE_INVALID = "Invalid or degraded usage response";
export const NO_ACTIVITY_THIS_PERIOD = "No activity this period";
